import { createAction, createReducer } from "@reduxjs/toolkit";

/** @type {boolean} */
const initialState = false;

export const showMenu = createAction("menu/Hide");
export const hideMenu = createAction("menu/Show");
export const toggleMenu = createAction("menu/Toggle");

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(showMenu, () => true)
    .addCase(hideMenu, () => false)
    .addCase(toggleMenu, (state) => !state);
});

export default reducer;
